<script>
  import { onMount } from 'svelte'
  import { timeStore, dataStore } from '../../stores'
  import Loader from '../Loader.svelte'
  import TimesModal from './TimesModal.svelte'
  import EditTimeModal from './EditTimesModal.svelte';
  import { Datatable } from 'svelte-simple-datatables';
  import { settings } from '../../../scripts/datatablesSettings';
  import { config } from '../../../scripts/defaultURL';
  import { formatDate } from '../../../scripts/functions';
  import { getData } from '../../../scripts/rest';

  // Add column ordering to settings
  settings.order = [0, "desc"];

  let initialized = false;
  let timeSelected = false;
  let timesData;
  let time;
  let clientsData;
  let clientOptions;
  let categoryOptions;
  let rows;

  $: if ($timeStore && $timeStore.todo == 'getData') {
    getData(`${config.defaultURL}/times`).then((data) => { timesData = data });
    $timeStore.todo = '';
  }

  $: if (timesData && clientsData) {
    initialized = true;
    if (!$dataStore) $dataStore = {};
    $dataStore['times'] = timesData;
    $dataStore['clients'] = clientsData;
    console.log('dataStore', $dataStore);

    genClientsOptions();
    genCategoryOptions();
  }

  $: if (document.getElementById('editTimeModal') && !document.getElementById('editTimeModal').classList.contains('is-active')) {
    timeSelected = false;
    time = null;
  }

  function genCategoryOptions() {
    const sorted = timesData.sort((a, b) => {
      const A = a.category ? a.category.toUpperCase() : null;
      const B = b.category ? b.category.toUpperCase() : null;
      if (A < B) return -1;
      if (B < A) return 1;
      return 0;
    });
    
    categoryOptions = [];
    
    sorted.forEach((item) => {
      if (item.category && categoryOptions.indexOf(item.category) == -1) {
        // console.log('item.category',item.category);
        categoryOptions.push(item.category);
      }
    });
  }

  function genClientsOptions() {
    const unique = [];
    const sorted = clientsData.sort((a, b) => {
      const A = a.first.toUpperCase();
      const B = b.first.toUpperCase();
      if (A < B) return -1;
      if (B < A) return 1;
      return 0;
    });
    
    clientOptions = [];
    
    sorted.forEach((item) => {
      if (unique.indexOf(item.id) == -1) {
        unique.push(item.id);
        clientOptions.push(item);
      }
    });
  }

  function openModal() {
    document.getElementById('timeModal').classList.add('is-active')
    initialized = false
  }

  function getClientName(clientId) {
    const filtered = clientsData.filter((item) => {
      return item.id == clientId;
    });

    if (filtered.length) return `${filtered[0].first} ${filtered[0].last}`;
    return '';
  }

  function editTimeModal(item) {
    time = item;
    // console.log('time item',time);
    timeSelected = true;
    
    const interval = setInterval(() => {
      if (document.getElementById('editTimeModal')) {
        clearInterval(interval);
        document.getElementById('editTimeModal').classList.add('is-active');
      }
    });
  }

  onMount(() => {
    getData(`${config.defaultURL}/times`).then((data) => { timesData = data });
    if (!$dataStore || !$dataStore.clients) getData(`${config.defaultURL}/clients`).then((data) => { clientsData = data });
    else clientsData = $dataStore.clients;
  })
</script>

<style>
  .table-container {
    overflow-y: auto;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;
  }

/* .slash {
  position: relative;
  top: -5px;
  font-size: 1.25rem;
} */

.table-container tbody tr {
  cursor: pointer;
}
</style>

<div class="flex">
  <div class="left">
    <h3>Times List</h3>
  </div>
  <div class="right">
    <button on:click={() => { openModal('timeModal') }} class="button is-primary">
      <span class="icon">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z" />
        </svg>
      </span>
      <span>Add Time</span>
    </button>
  </div>
</div>
{#if initialized}
  <div class="table-container">
    <Datatable settings={settings} data={timesData.sort((a,b) => { return new Date(b.date) - new Date(a.date) })} bind:dataRows={rows}>
      <thead>
        <tr>
          <th data-key="date">Date</th>
          <th data-key="amount">Minutes</th>
          <th data-key="description">Description</th>
          <th data-key="category">Category</th>
          <th data-key="client_id">Client</th>
        </tr>
      </thead>
      <tbody>
        {#if rows}
        {#each $rows as item}
          <tr id={item.id} on:click={() => {editTimeModal(item)}}>
            <td>{formatDate(item.date)}</td>
            <td>{item.minutes}</td>
            <td>{item.description}</td>
            <td>{(item.category) ? item.category : ''}</td>
            <td>{(item.client_id) ? getClientName(item.client_id) : ''}</td>
          </tr>
        {/each}
        {/if}
      </tbody>
    </Datatable>
  </div>
{:else}
  <!-- Insert loading animation -->
  <Loader />
{/if}
{#if clientOptions && categoryOptions}
<TimesModal {clientOptions} {categoryOptions} />
{/if}
{#if timeSelected && categoryOptions}
<EditTimeModal {time} {categoryOptions} />
{/if}